import { render, staticRenderFns } from "./addArea.vue?vue&type=template&id=576f7e4e&scoped=true&"
import script from "./addArea.vue?vue&type=script&lang=js&"
export * from "./addArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f7e4e",
  null
  
)

export default component.exports